import { ITelemetryBaseEvent, ITelemetryProperties } from '@fluidframework/common-definitions';
import { ITelemetryNamespaceLogger } from '@fluidx/office-fluid-types';

export class NamespaceLoggerAdapter implements ITelemetryNamespaceLogger {
  private logger: ITelemetryNamespaceLogger | null;

  public get NamespaceLogger() {
    return this;
  }

  constructor(
    private readonly namespace: string,
    logger: ITelemetryNamespaceLogger,
    private persistedProperties?: ITelemetryProperties
  ) {
    this.logger = logger;
  }

  public addPersistedProperties(properties: ITelemetryProperties) {
    this.persistedProperties = { ...this.persistedProperties, ...properties };
  }

  send(event: ITelemetryBaseEvent) {
    this.sendWithNamespace(event, this.namespace);
  }

  sendWithNamespace(event: ITelemetryBaseEvent, namespace: string) {
    this.logger && this.logger.sendWithNamespace({ ...event, ...this.persistedProperties }, namespace);
  }

  dispose() {
    // On dispose, set the logger to null
    // This acts as a signal not to send any more logs (e.g., to avoid logging
    // errors after an iframe has already been disposed).
    // It may also help avoid memory leaks (though we weren't observing any such issues in this flow anyway).
    this.logger = null;
  }
}
